var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 100 100",
    height: 100,
    width: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212121",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3 4.7v82.9l-9.9-10c-1.1-1.1-2.8-1.1-3.9 0s-1.1 2.8 0 3.9l16.6 16.6 1.9-1.9 14.6-14.7c.5-.5.8-1.2.8-1.9s-.3-1.4-.8-1.9c-1.1-1.1-2.8-1.1-3.9 0l-9.9 9.9V4.7C52.8 3.2 51.6 2 50 2c-1.5 0-2.7 1.2-2.7 2.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.ca42815691585f8ddc15fa87c72adf14.svg";
export { ForwardRef as ReactComponent };